import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const alertVariants = cva(
    "relative w-full rounded-lg border p-4",
    {
        variants: {
            variant: {
                default: "bg-background text-foreground",
                destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
                success: "border-green-200 bg-green-50 text-green-800 [&>svg]:text-green-600",
                warning: "border-yellow-200 bg-yellow-50 text-yellow-800 [&>svg]:text-yellow-600",
                info: "border-blue-200 bg-blue-50 text-blue-800 [&>svg]:text-blue-600",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

const Alert = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement> & {
        variant?: "default" | "destructive" | "success" | "warning" | "info"
        icon?: React.ReactNode
    }
>(({ className, variant = "default", icon, children, ...props }, ref) => {
    return (
        <div
            ref={ref}
            role="alert"
            className={cn(alertVariants({ variant }), className)}
            {...props}
        >
            <div className="flex items-start gap-4">
                {icon && (
                    <div className="flex-shrink-0 pt-0.5">
                        {icon}
                    </div>
                )}
                <div className="flex-1">{children}</div>
            </div>
        </div>
    )
})
Alert.displayName = "Alert"

export { Alert, alertVariants } 